export default "https://cdn-static.gokick.com/assets/be369b33e14920b1856d71de34d484ec78759d8a/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";